import { PersonName, PersonNameVariables } from './__generated__/PersonName'
import { useApolloClient, useQuery } from '@apollo/react-hooks'

import { gql } from 'apollo-boost'

const QUERY = gql`
  query PersonName($personId: String!) {
    person(id: $personId) {
      id
      firstName
      lastName
    }
  }
`

export const useGetPersonNameLazyQuery = () => {
  const client = useApolloClient()

  return async (personId: string) => {
    return await client.query<PersonName, PersonNameVariables>({
      query: QUERY,
      variables: {
        personId
      }
    })
  }
}

interface IGetPersonQuery {
  skip?: boolean
  variables: PersonNameVariables
}

export const useGetPersonQuery = (input: IGetPersonQuery) => {
  return useQuery<PersonName, PersonNameVariables>(QUERY, input)
}
